import { render } from "./TheErrorPane.vue?vue&type=template&id=70e47b6e"
import script from "./TheErrorPane.vue?vue&type=script&lang=js"
export * from "./TheErrorPane.vue?vue&type=script&lang=js"

import "./TheErrorPane.vue?vue&type=style&index=0&id=70e47b6e&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__